import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { HeaderLink, PageHeaderLink } from "./helpers/elements";
import React, { useEffect, useRef, useState } from "react";
import useFetch from "./helpers/useFetch";
import { useAtomValue } from "jotai/index";
import { tokenState } from "./Home";
import { StyleProcessor } from "./helpers/StyleProcessor";
import Modes from "./Modes";
import NEH from "./NappsEventHandlers";
import { truncate_letters } from "./helpers/utils";
import { useDeviceWidth } from "./useDeviceWidth";
import { NavBar } from "./Base";
import axios from "axios";
import { getApp } from "./loaders/appLoaders";

export async function loader({ params }) {
  const app = await getApp(params.appNameId);
  return { app };
}

function UpdateAppsForm() {
  const { app } = useLoaderData();
  const appData = app?.data;
  // const { id } = useParams();
  // const navigate = useNavigate();
  // const [appData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/${id}/`);
  const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();

  const [appCreateData, setAppCreateData] = useState({});
  const [isAppCategoryModesOpen, setIsAppCategoryModesOpen] = useState(false);
  const [app_description_textarea_value, setAppDescriptionValue] = useState();
  const selectedCategoryContainer = useRef(null);
  // const {rawToken, isLoggedIn, tokenData} = useTokenData();
  const { rawToken, isLoggedIn, tokenData } = useAtomValue(tokenState);
  // const {rawToken, isLoggedIn, tokenData} = useRecoilValue(tokenState);
  const navigate = useNavigate();
  const [appImage, setAppImage] = useState(null);
  const [appImagePreview, setAppImagePreview] = useState(null);
  const [appScreenshots, setAppScreenshots] = useState([]);
  const [appScreenshotsPreview, setAppScreenshotsPreview] = useState([]);
  const defaultAppsCategory = 'Finance, Technology, Science, Education, Lifestyle, Productivity, Wearable, Fitness, Creativity, Hardware'
  const [selectedCategoryCount, setSelectedCategoryCount] = useState(0);
  const [selectedCategoryData, setSelectedCategoryData] = useState('');
  const [selectedCategoryList, setSelectedCategoryList] = useState([]);
  const categoryItemsContainer = useRef(null);
  const categoryInputField = useRef(null);

  const handleAppImageChange = (event) => {
    const selectedImage = event.target.files[0];
    setAppImage(selectedImage);
    setAppImagePreview(URL.createObjectURL(selectedImage));
  };

  const handleAppScreenshotSelect = (event) => {
    const files = Array.from(event.target.files);
    setAppScreenshots(files);
    setAppScreenshotsPreview(
      files.map((file) => URL.createObjectURL(file))
    );
  };

  function addToSelectedCategory(event) {
    const category_value_elem = document.querySelector('#id-new-app-category-value')
    const this_elem = event.currentTarget
    const category_name = this_elem.getAttribute('data-category_name')

    // if (categorySplit.length <= 4) {
    if (this_elem.getAttribute('data-category_item_selected') === 'false') {
      let categorySplit = category_value_elem.value.split(',');
      category_value_elem.value += `${category_name},`.trim();
      setSelectedCategoryData(category_value_elem.value);
      new StyleProcessor(this_elem).removeClass('bg-transparent').addManyClass('bg-green color-FFFFFF pct:w-96 mg-x-auto mg-y-2');
      this_elem.setAttribute('data-category_item_selected', true);
      selectedCategoryContainer.current.innerHTML += `<span id="id-category-${categorySplit.length}" class="d-inline-block h-5 lh-5 pad-x2 mg-x1 mg-y1 radius-round bg-lighter border:1px_solid_BBB font-bold">${category_name}</span>`;
      setSelectedCategoryCount(selectedCategoryCount + 1);
      if (selectedCategoryCount === 4 - 1) {
        categoryItemsContainer.current.childNodes.forEach((obj) => {
          if (obj.getAttribute('data-category_item_selected') === "false") {
            obj.setAttribute('disabled', 'true');
          }
        }, this_elem);
      }
    } else if (this_elem.getAttribute('data-category_item_selected') === 'true') {
      const removeItemFromList = (arr, itemToRemove, countToRemove = 1) => {
        let index = arr.indexOf(itemToRemove);
        if (index !== -1) {
          // If the item is found in the array
          arr.splice(index, countToRemove); // remove the item from the array
        }
        return arr;
      }
      // this element has already been selected,
      // reverse the selection.
      // category_value_elem.value -= `${category_name}, `;
      category_value_elem.value = category_value_elem.value.replace(`${category_name},`.trim(), '');
      setSelectedCategoryData(category_value_elem.value);
      new StyleProcessor(this_elem).addClass('bg-transparent').removeManyClass('bg-green color-FFFFFF pct:w-96 mg-x-auto mg-y-2');
      this_elem.setAttribute('data-category_item_selected', false);
      selectedCategoryContainer.current.querySelector(`#id-category-${selectedCategoryCount}`).remove();
      setSelectedCategoryCount(selectedCategoryCount - 1);
      if (selectedCategoryCount < 4 + 1) {
        categoryItemsContainer.current.childNodes.forEach((obj) => {
          if (obj.getAttribute('data-category_item_selected') === "false") {
            obj.removeAttribute('disabled');
          }
        }, this_elem);
      }
    }
    //  } else if (categorySplit.length === 4) {
    //   console.log("Max number of category reached")
    //   categoryItemsContainer.current.childNodes.forEach((obj) => {
    //     if (obj.getAttribute('data-category_item_selected') === "false") {
    //       obj.setAttribute('disabled');
    //     }
    //   }, this_elem);
    // } else {
    //   alert('Only four categories allowed.')
    //   // new Notification().addNotification("You can only select four categories.");
    // }
  }

  function NewAppCategory(props) {
    // let state = {
    //     category_item_selected: false,
    // }
    const default_apps_category = 'Finance, Technology, Science, Education, Lifestyle, Productivity, Wearable, Fitness, Creativity, Hardware'
    const [selectedCategoryCount, setSelectedCategoryCount] = useState(0);
    const categoryItemsContainer = useRef(null);
    const [isModesOpen, setIsModesOpen] = useState(props.isOpen);

    useEffect(() => {
      if (props.isOpen) {
        setIsModesOpen(props.isOpen)
      }
      return () => { }
    }, [props.isOpen]);

    /*function addToSelectedCategory(event) {
      const category_value_elem = document.querySelector('#id-new-app-category-value')
      const this_elem = event.currentTarget
      const category_name = this_elem.getAttribute('data-category_name')

      if (category_value_elem.value.split(',').length <= 4) {
        if (this_elem.getAttribute('data-category_item_selected') === 'false') {
          category_value_elem.value += `${category_name}, `;
          // this_elem.classList.add('bg-green')
          new StyleProcessor(this_elem).removeClass('bg-lighter').addManyClass('bg-green pct:w-96 mg-x-auto mg-y-2 bg-d0dad5');
          this_elem.setAttribute('data-category_item_selected', true);
          // console.log(selectedCategoryContainer.current.innerHTML)
          selectedCategoryContainer.current.innerHTML += `<span class="d-inline-block h-5 lh-5 pad-x2 mg-x1 mg-y1 radius-round bg-lighter border:1px_solid_BBB font-bold">${category_name}</span>`;
          setSelectedCategoryCount(selectedCategoryCount+1);
          console.log(typeof this_elem.getAttribute('data-category_item_selected'));
        } else if (this_elem.getAttribute('data-category_item_selected') === 'true') {
          // this element has already been selected,
          // reverse the selection.
          console.log(category_value_elem.value);
          category_value_elem.value -= `${category_name}, `;
          category_value_elem.value = category_value_elem.value.replace(`${category_name}, `, '');
          console.log(category_value_elem.value);
          // this_elem.classList.add('bg-green')
          new StyleProcessor(this_elem).addClass('bg-lighter').removeManyClass('bg-green pct:w-96 mg-x-auto mg-y-2 bg-d0dad5');
          this_elem.setAttribute('data-category_item_selected', false);
          // console.log(selectedCategoryContainer.current.innerHTML)
          selectedCategoryContainer.current.remove += `<span class="d-inline-block h-5 lh-5 pad-x2 mg-x1 mg-y1 radius-round bg-lighter border:1px_solid_BBB font-bold">${category_name}</span>`;
          setSelectedCategoryCount(selectedCategoryCount-1);
        }
      } else if (category_value_elem.value.split(',').length === 4) {
        console.log("Max number of category reached")
        categoryItemsContainer.current.childNodes.forEach((obj) => {
          if (obj.getAttribute('data-category_item_selected') === "false") {
            obj.setAttribute('disabled');
          }
        }, this_elem);
      } else {
        alert('Only four categories allowed.')
        // new Notification().addNotification("You can only select four categories.");
      }
    }*/

    const closeModes = () => {
      setIsModesOpen(!props.isOpen);
    };
    return (
      <section className="" ref={categoryItemsContainer}>
        <Modes isOpen={isAppCategoryModesOpen} modesId={"id-new-app-category-modes"} modesClass={"modes-white modes-fullscreen"} show_modes={false}>
          <section className="h-10 line-height-10 text-center pad-x-3 font-18 font-bold">Category</section>
          <div className="d-block abs px:top-8 right-4 h-8 lh-8 pad-x1 text-center font-bold">{selectedCategoryCount} of 4</div>
          <div
            className="abs bottom-0 left-0 right-0 w-240 line-height-8 mg-x-auto mg-b2 radius2-smr bg-light text-center font-14"
            // onClick={new NEH().closeNewAppsCategoryTemplate}>Close
            onClick={closeAppCategoryModes}>Close
          </div>
          {/*<section className="" onClick={new NEH().closeNewAppsCategory}></section>*/}
          <button
            type={"button"}
            className={"fa fa-times font-18 d-block abs top-1 left-2 z-100 square-8 lh-8 border-0 text-center radius-circle bg-initial decoration-none color-initial"}
            onClick={closeAppCategoryModes}
          ></button>
          {default_apps_category.split(',').map((each_apps_category, _) => {
            return (
              <button type={"button"} key={_}
                className="d-block h-8 lh-8 pad-x3 pad-y-3 border-0 bg-transparent radius2 text-left hover:pct:w-96|mg-x-auto|bg-d0dad5 transition:all_200ms_ease disabled:color-orange"
                data-category_name={each_apps_category}
                data-category_item_selected={false}
                onClick={(event) => addToSelectedCategory(event)}>{each_apps_category}</button>
            )
          })}
        </Modes>
      </section>
    )
  }

  function appDescriptionChange(event) {
    const this_elem = event.currentTarget
    // this_elem.value = this_elem.innerHTML;
    // alert(this_elem.value);
    // this_elem.value = event.currentTarget.value;
    // alert(this_elem.value)
    // return this_elem.setAttribute("value", this_elem.value);
    setAppDescriptionValue(this_elem.value)
  }

  function submitNewAppForm(event) {
    event.preventDefault();
    console.log('Initializing submitting new App Form.');
    const formData = new FormData(event.currentTarget);
    appScreenshots.forEach((file, index) => {
      // formData.append(`images[${index}]`, file)
      formData.append(`screenshots`, file)
    });
    const newAppApiUrl = `${process.env.REACT_APP_BASE_URL}/app/`;
    const newAppFetchConfig = {
      method: 'POST',
      headers: {
        // 'Accept': '*',
        // 'Origin': '*',
        'Authorization': `Bearer ${rawToken}`,
        // 'Content-Type': "multipart/form-data"
      },
      // body: formData,
      data: formData,
      modes: 'cors',
    }
    // fetch(newAppApiUrl, newAppFetchConfig)
    axios(newAppApiUrl, newAppFetchConfig)
      .then(response => {
        console.log("Received response")
        console.log(response.status)
        console.log(typeof response.status)
        if (response.status >= 400) {
          throw new Error("Error updating app");
        }
        new NEH().closeNewAppsFormTemplate()
        // return response.json()
        return response.data
      })
      .then(data => {
        console.info(`New App instance created successfully. ::`)
        console.info(data)
        // Show the success alert and redirect to the home page
        setTimeout(() => {
          navigate('/');
        }, 800);
      })
      .catch(err => {
        console.error(`Error occurred when creating new App. :: ${err}`)
      })

    // reset the form data
    setAppScreenshots([]);
    setAppScreenshotsPreview([]);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setAppCreateData(values => (
      { ...values, [name]: value }
    ));
  }
  const drawNewAppCategoryModes = () => {
    setIsAppCategoryModesOpen(true);
  };

  const closeAppCategoryModes = () => {
    setIsAppCategoryModesOpen(false);
  };
  return (
    <section
      className="update-app-form-container flex flex-column justify-start align-items-start pct:w-100 pct:h-100 overflow-x-hidden dark:bg-111314">
      {/*<section
        className="new-app-banner lg:pct:w-28 pct:h-86 mg-r4 bg-f9f9f9 bg-mica radius-inherit border-1 border-eeeeee">
        <section className="bg-00995544"></section>
      </section>*/}
      {
        windowWidth < deviceWidthEnum.laptop
          ? <PageHeaderLink headerTitle={"Update your app"} fixTop={true} />
          : <NavBar />
      }

      <section className={"fixed px:top-80 flex flex-column justify-center align-items-center pct:w-100 h-200 mg-x-auto bg-light text-center lg:relative|px:top-0|min-h-480|pad-y8 dark:bg-000304"}>
        <div className={"font-30 lh-normal pct:w-80 lg:font-60"}>
          <div className={"font-size-inherit dark:color-whitesmoke"}>Update</div>
          <div className={"font-size-inherit font-bold color-gray dark:color-darkgray"}>{appData?.name}</div>
        </div>
        {/*<Link to={"logo"}*/}
        {/*      className={"d-block pad-y4 text-center decoration-none color-initial"}>*/}
        {/*    {*/}
        {/*        appData?.logo*/}
        {/*            ? <img src={appData?.logo} alt={`${appData?.name} logo`}*/}
        {/*                   className="d-block mg-x-auto w-104 h-104 bg-light radius-circle object-cover object-center"/>*/}
        {/*            : <div*/}
        {/*                className={"relative d-block mg-x-auto square2-1 lh2-1 radius-circle border-0 border-DDD border-solid bg-green color-white text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease"}>*/}
        {/*                {appData?.name.split('')[0].toUpperCase().toString()}*/}
        {/*            </div>*/}
        {/*    }*/}
        {/*</Link>*/}
      </section>
      <section className={"relative px:top-280 d-block pct:w-100 z-1 lg:px:top-0|pct:w-56|mg-x-auto"}>
        <div
          className={"d-none sticky px:top-80 flex flex-row flex-nowrap pct:w-100 h-8 lh-8 bg-green-inverse bg-mica4 overflow-x-auto z-10 every:d-block|flex-grow|flex-noshrink|decoration-none|pad-x2"}>
          {
            ["overview", "screenshots", "basic info", "category", "links", "app management"].map((eachTab, index) => (
              <span key={index}>{eachTab}</span>
            )
            )
          }
        </div>

        <section className={"overview-container relative"}>
          {/* Contains:
                  - App logo
                  - App screenshots
                  - App name
                  - App description
                  - App version
                  - App category
                  - App download links
                  - App website
                  - App management (settings, delete, under-construction, beta etc.)
                  */}
          <AppOverview {...appData} />
        </section>
      </section>
    </section>
  )
}

function AppOverview(props) {
  return (
    <section className={"bg-light pad-t1 lg:pad-unset dark:bg-111314"}>
      <section>
        {/* App logo */}
        <div className={"relative d-block pct:w-100 pad-t2 pad-b8 bg-white-solid dark:bg-111314BB dark:color-whitesmoke"}>
          <Link to={"logo"} className={"d-inline-block v-align-middle pct:w-100 decoration-none color-initial"}>
            <header className={"d-inline-block pct:w-80 font-semibold font-14 pad-x2 lg:font-18 dark:color-darkgray"}>App Logo</header>
            <div
              className={"d-inline-block pct:w-20 text-right"}>
              <span className={"fa fa-angle-right square-8 lh-8 color-initial text-center decoration-none dark:color-whitesmoke"}></span>
            </div>
          </Link>
          <div className={"flex flex-row align-items-center pad-x2"}>
            <span className={"lg:font-14|lh-40"}>Use a logo that personalizes <b>{props.name}</b></span>
            {
              props.logo
                ? <img src={props.logo} alt={`${props.name} logo`} width={"48"} height={"48"}
                  className="d-block mg-l-auto w-48 h-48 bg-light radius-circle object-cover object-center lg:w-80|h-80|lh-80" />
                : <div
                  className={"relative d-block mg-l-auto square-6 lh-6 radius-circle border-0 border-DDD border-solid bg-light color-initial text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease lg:square-10|lh-10"}>
                  {props?.name?.split('')[0].toUpperCase().toString()}
                </div>
            }
          </div>
        </div>

        {/* App screenshots*/}
        <div className={"mg-t-1 pad-t4 pad-b8 bg-white-solid dark:bg-111314BB"}>
          <HeaderLink headerTitle={"Screenshots"} showArrow={true} linkUrl={"screenshots"} />
          <section className={"flex flex-row flex-nowrap justify-start pct:w-100 every:radius-sm dark:bg-111314BB"}>
            {
              props?.screenshot?.length > 0
                ? props?.screenshot.map((image, index) => (
                  <>
                    <div className={"pct:w-100 h-240 pad-x-2 bg-lighter radius-inherit dark:bg-inherit"}>
                      <img key={index} src={image.image}
                        alt={`screenshot preview ${index}`} height={"100%"}
                        className={"pct:max-w-100 object-cover object-center radius-inherit"} />
                    </div>
                    {/*<div className={"abs bottom-0 pct:w-100 bg-transparent"}></div>*/}
                  </>
                ))
                : <div
                  className={"flex flex-column justify-center align-items-center pct:w-96 h-160 border:2px_dashed_DDD mg-x-auto mg-t2 radius color-BBB dark:border:2px_dashed_darkgray"}>
                  <span className="fa fa-plus font-24 pad-y2"></span>
                  <div>Select images to upload</div>
                </div>
            }
          </section>
        </div>

        {/* App name and Description */}
        <div className={"mg-t-1 pad-t4 pad-b4 bg-white-solid dark:bg-111314BB"}>
          <HeaderLink headerTitle={"Basic Info"} showArrow={true} linkUrl={"basic-info"} />
          <div className="relative pad-t2 pad-b2 pad-x2 font-13 bg-white-solid lg:font-14|lh-40|pad-y3 dark:bg-111314BB dark:color-whitesmoke">
            <div className={"h4 lh-4 font-11 font-medium lg:font-12"}>App name:</div>
            {props.name}
          </div>
          <div className="pad-x2 pad-y1 bg-white-solid font-13 lg:font-13|lh-40|pad-y3 dark:bg-111314BB dark:color-whitesmoke">
            <div className={"h4 lh-4 font-11 font-medium lg:font-12"}>Description:</div>
            {props.truncate_description ? truncate_letters(props.description, 0, 160) : props.description}
          </div>
          <div className="pad-x2 pad-y1 bg-white-solid font-13 lg:font-14|lh-40|pad-y3 dark:bg-111314BB dark:color-whitesmoke">
            <div className={"h4 lh-4 font-11 font-medium lg:font-12"}>Version:</div>
            {props.version || "-"}
          </div>
          <div className="pad-x2 pad-y1 bg-white-solid font-13 lg:font-14|lh-40|pad-y3 dark:bg-111314BB dark:color-whitesmoke">
            <div className={"h4 lh-4 font-11 font-medium lg:font-12"}>Website:</div>
            {props.website || "-"}
          </div>
        </div>

        {/* App category */}
        <div className={"mg-t-1 pad-t4 pad-b4 bg-white-solid dark:bg-111314BB"}>
          <HeaderLink headerTitle={"Category"} showArrow={true} linkUrl={"category"} />
          <div className="flex flex-column pad-y1 pad-x1 overflow-x-auto">
            {
              props.category
                ? props.category?.split(',').map((each_app_category, index) => (
                  <span
                    key={index}
                    className="d-block pad-x2 h-6 lh-6 mg-x1-smt mg-y1-smt radius bg-light font-normal font-12 lg:font-14|h-8|lh-8|mg-y1-sm dark:bg-333435|color-darkgray">
                    {each_app_category}
                  </span>
                ))
                : <div className={"font-14 color-gray text-center pad-2"}>No selected category</div>
            }
          </div>
        </div>

        {/* App download links */}
        <div className={"mg-t-1 pad-t4 pad-b4 bg-white-solid dark:bg-111314BB"}>
          <HeaderLink headerTitle={"Download links"} showArrow={true} linkUrl={"download-links"} />
          <section className={"every:d-block|pad-2"}>
            <div id="id-app-download-links"
              className={"color-initial lg:font-14 dark:color-whitesmoke"}>
              <span className="fab fa-google-play square-6 lh-6 font-18 color-444 dark:color-darkgray"></span>
              {props.playstore_link ? "Download from Google play store" : "-"}
            </div>
            <div id="id-app-download-links"
              className={"color-initial lg:font-14 dark:color-whitesmoke"}>
              <span className="fab fa-app-store-ios square-6 lh-6 font-18 color-444 dark:color-darkgray"></span>
              {props.appstore_link ? "Download from Apple AppStore" : "-"}
            </div>
            <div id="id-app-download-links"
              className={"color-initial lg:font-14 dark:color-whitesmoke"}>
              <span
                className="fa fa-link square-6 lh-6 font-18 color-444 dark:color-darkgray"></span>{props.external_link ? "External download link" : "-"}
            </div>
          </section>
        </div>

        {/* App Management */}
        <div className={"mg-t-4 pad-t4 pad-b4 bg-white-solid dark:bg-111314BB"}>
          <HeaderLink headerTitle={"App management"} showArrow={false} />
          <section className={"every:d-block|pad-2"}>
            <div id="id-app-download-links"
              className={"color-lightgray dark:color-333435"}>
              <span className="fa fa-gear square-6 lh-6 font-18 color-lightgray dark:color-333435"></span>
              {"Settings"}
            </div>
            <div id="id-app-download-links"
              className={"color-lightgray dark:color-333435"}>
              <span
                className="fa fa-hammer square-6 lh-6 font-18 color-lightgray dark:color-333435"></span>
              {"Under construction"}
            </div>
            <div id="id-app-download-links"
              className={"color-lightgray dark:color-333435"}>
              <span
                className="fa fa-flask square-6 lh-6 font-18 color-lightgray dark:color-333435"></span>
              {"Beta"}
            </div>
            <Link to={`../app/${props.name_id}/delete`} id="id-app-download-links"
              className={"font-bold color-red decoration-none"}>
              <span className="fa fa-trash square-6 lh-6 font-18"></span>
              {"Delete"} {props.name}
            </Link>
          </section>
        </div>
      </section>
    </section>
  )
}

export const AppDetailLeftNav = ({ appName, pageName }) => {
  const navLinks = ["Logo", "Basic-info", "Screenshots", "Category", "Download-links"];
  return (
    <section className={"sticky top-0 pct:w-20 vh:h-100 bg-lighter dark:bg-222425 dark:lg:bg-000304"}>
      <Link to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/`}
        className={"flex flex-column justify-center align-items-start font-18 lh-normal pct:w-100 h-160 pad-x4 color-initial decoration-none hover:decoration-2|underline lg:font-24 dark:color-whitesmoke"}>
        <div className={"font-size-inherit"}>Update</div>
        <div className={"font-size-inherit font-bold color-gray"}>{appName}</div>
      </Link>
      <section
        className={"d-block every:d-block|pad-4|radius|decoration-none|color-initial hover:every:bg-light dark:every:color-whitesmoke dark:hover:every:bg-222425"}>
        {
          navLinks.map((eachNavLink, index) => {
            if (pageName !== eachNavLink) {
              return (
                <Link
                  to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/${eachNavLink.toLowerCase()}`}>
                  {eachNavLink.replace("-", " ")}
                </Link>
              )
            }
          })
        }
        {/*<Link
                    to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/screenshots`}>Basic info</Link>
                <Link
                    to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/screenshots`}>Screenshots</Link>
                <Link
                    to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/category`}>Category</Link>
                <Link
                    to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/download-links`}>Download
                    links</Link>*/}
      </section>
    </section>
  )
}
const UpdateAppDetail = () => {
  return (
    <UpdateAppsForm />
  )
}
export default UpdateAppDetail;